import { createIFramedMicroapp } from './utils.js';

/**
 * Initializes LogRocket with specified child domains.
 */
const initLogRocket = () => {
  window.emui.logRocketConfig.childDomains = [
    'https://vinothkumarvk.com',
    'https://beta.vinothvk.com',
  ];
  window.emuiLogrocket.initLogRocket({ isReact: false });
};

// report custom event to logrocket
const reportCustomEvent = (eventName, eventData) => {
  if (window.emuiLogrocket) {
    window.emui.logRocket.track(eventName, eventData);
  }
};

/**
 * Event handler for the "load-nested-app-btn" button click event.
 */
const onLoadNestedAppClick = () => {
  createIFramedMicroapp(
    `https://beta.vinothvk.com/microapp2-1-cross-domain.html`,
  );
  reportCustomEvent('nested_app_open', { timestamp: Date.now().toString() });
};

/**
 * Event handler for the "print-date-btn" button click event.
 */
const onPrintDateClick = () => {
  const dateOutput = document.getElementById('date-output');
  dateOutput.textContent = `Current Date and Time: ${new Date().toLocaleString()}`;
  reportCustomEvent('print_date', { date: Date.now().toString() });
};

/**
 * Event handler for the window load event.
 */
const onLoad = () => {
  const loadNesstedAppBtn = document.getElementById('load-nested-app-btn');
  loadNesstedAppBtn.addEventListener('click', onLoadNestedAppClick);
  const printDateBtn = document.getElementById('print-date-btn');
  printDateBtn.addEventListener('click', onPrintDateClick);
};

if (window.emuiLogrocket) initLogRocket();
window.addEventListener('load', onLoad);
